<section class="registration-status" aria-live="polite">
  <div class="status-brand">
    <img src="assets/images/qb_logo_white.svg" alt="Quickboard" />
  </div>

  <div class="status-content" *ngIf="registerSuccess.value === null" role="status">
    <div class="status-spinner" aria-hidden="true"></div>
    <span class="status-kicker">Please wait</span>
    <h2>{{ data.paymentRequired ? "Processing your payment" : "Creating your account" }}</h2>
    <p>
      {{
        data.paymentRequired
          ? "Your order is being securely submitted. Keep this window open."
          : "We are preparing your Quickboard account. Keep this window open."
      }}
    </p>
  </div>

  <div class="status-content" *ngIf="registerSuccess.value === true">
    <div class="status-illustration-frame">
      <img class="status-illustration" src="assets/images/success.png" alt="Registration successful" />
    </div>
    <span class="status-kicker success">Registration complete</span>
    <h2>
      Welcome, {{ data.personalDetailsForm.controls["firstName"].value }}
      {{ data.personalDetailsForm.controls["lastName"].value }}.
    </h2>
    <p *ngIf="data.paymentRequired">Your subscription is active and your payment was processed.</p>
    <p *ngIf="!data.paymentRequired">Your free account is ready to use in the Quickboard iPad app.</p>
    <p class="redirect-note">You will be redirected automatically.</p>
    <button type="button" class="status-button" (click)="redirectToDashboard()">
      {{ data.paymentRequired ? "Go to dashboard" : "Continue" }}
    </button>
  </div>

  <div class="status-content" *ngIf="registerSuccess.value === false" role="alert">
    <div class="status-illustration-frame">
      <img class="status-illustration" src="assets/images/fail.png" alt="Registration failed" />
    </div>
    <span class="status-kicker error">Something went wrong</span>
    <h2>We could not complete your registration.</h2>
    <p>{{ registerError || "Please review your information and try again." }}</p>
    <button type="button" class="status-button" (click)="dialogRef.close(true)">
      Back to checkout
    </button>
  </div>
</section>
